import React, { useState, useEffect } from "react";
import { Typography, Row, Col, Card, Tabs } from "antd";
import { getStatistics } from "../api/dashboard/dashboardRequest";
import Loading from "../components/Loading";
import RecentInfractions from "../components/RecentInfractions";

import { formatMonthlyData } from "../utils/constants";
import MonthlyRevenueChart from "../components/MonthlyRevenueChart";
import WeeklyInfractionChart from "../components/WeeklyInfractionChart";
import UserStatisticsChart from "../components/UserStatisticsChart";
import TypesDistributionChart from "../components/TypesDistributionChart";
import EnhancedStatistics from "../components/EnhancedStatistics";
import { useSelector } from "react-redux";
import { hasPermission, selectUser } from "../store/userSlice";
import WeeklyWarningChart from "../components/WeeklyWarningChart";

const { Title } = Typography;
const { TabPane } = Tabs;

const Dashboard = () => {
  const user = useSelector(selectUser);
  const checkPermission = useSelector((state) =>
    hasPermission(state, "dashboard", "view")
  );
  const [dashboardData, setDashboardData] = useState({
    dailyRevenue: 0,
    monthlyRevenue: 0,
    dailyInfractions: 0,
    monthlyInfractions: 0,
    monthlyRevenueBreakdown: [],
    infractionTypeData: [],
    lastFiveInfractions: [],
    infractionOfLast7Day: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (checkPermission) {
      const fetchDashboardData = async () => {
        try {
          const data = await getStatistics();
          setDashboardData(data);
        } catch (error) {
          console.error("Error fetching dashboard data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchDashboardData();
      const interval = setInterval(fetchDashboardData, 300000); // Refresh every 5 minutes
      return () => clearInterval(interval);
    }
  }, []);

  if (!checkPermission) {
    return (
      <div>
        <Title level={2} className="px-6">
          {user.full_name}
        </Title>
      </div>
    );
  }

  if (loading) return <Loading />;

  return (
    <>
      <div></div>
      <div className="px-6 bg-purple-50 min-h-screen">
        <Title level={2} className="my-2">
          {user.full_name}
        </Title>

        <EnhancedStatistics
          dashboardData={{
            ...dashboardData,
          }}
        />
        <Row gutter={[16, 16]} className="my-5">
          <Col xs={24} md={24} lg={24} xl={12} xxl={12}>
            <RecentInfractions
              infractions={dashboardData?.lastFiveInfractions}
              warnings={dashboardData?.lastFiveWarnings}
            />
          </Col>
          <Col xs={24} md={24} lg={24} xl={12} xxl={12}>
            <Card className="hover:shadow-lg transition-shadow  h-full">
              <Tabs defaultActiveKey="1">
                <TabPane tab="Revenus Mensuels" key="2">
                  <MonthlyRevenueChart
                    data={formatMonthlyData(
                      dashboardData?.monthlyRevenueBreakdown
                    )}
                  />
                </TabPane>
                <TabPane tab="Infractions Hebdomadaires" key="3">
                  <WeeklyInfractionChart
                    data={dashboardData?.infractionOfLast7Day}
                  />
                </TabPane>
                <TabPane tab="Avertissements Hebdomadaires" key="1">
                  <WeeklyWarningChart data={dashboardData?.warningOfLast7Day} />
                </TabPane>
              </Tabs>
            </Card>
          </Col>
          <Col xs={24} md={24} lg={24} xl={12} xxl={12}>
            <Card className="hover:shadow-lg transition-shadow h-full">
              <TypesDistributionChart
                infractionData={dashboardData?.infractionTypeData}
                warningData={dashboardData?.warningTypeData}
              />
            </Card>
          </Col>
          <Col xs={24} md={24} lg={24} xl={12}>
            <UserStatisticsChart data={dashboardData?.userStatistics} />
          </Col>
        </Row>

        <Row gutter={[16, 16]}></Row>
      </div>
    </>
  );
};

export default Dashboard;